
import ShareHolderAnalysis from "components/housingCompany/details/ShareHolderAnalysis/ShareHolderAnalysis";

function ShareHolder(props: any) {
    const selectedTab = 3;
    return (
        <>
            <ShareHolderAnalysis props={props} selectedTab={selectedTab}/>
        </>
    );
}

export default ShareHolder;